<template>
  <div class="appeal" :style="(currentIndex != 0 && !$isFlag) ? 'background:#fff' : ''">
    <header-item
      :title-array="titleArray"
      :is-show="true"
      :title-mb="titleArray[0]"
      type-next="click"
      @navBarClick="navBarClick"
    />
    <!-- form -->
    <div class="lt-freeze-form">
      <van-form class="appealInfo">
        <!-- 绑定手机号 -->
        <van-field
          v-model="unfreezeParams.phone"
          label="绑定手机号："
          required
          :rules="rules.mobileRules"
          placeholder="请输入账号绑定手机号"
        />
        <!-- 短信验证码 -->
        <van-field
          v-model="unfreezeParams.phoneCode"
          label="短信验证码："
          maxlength="6"
          required
          style="border-radius: 0 0 16px 16px;"
          :rules="rules.codeRules"
        >
          <template #button>
            <p v-if="!showTime" style="color: #616edf; cursor: pointer" @click="getCode">{{ timeMsg }}</p>
            <p v-else style="color: #878787; cursor: pointer">{{ codeTime }} S</p>
          </template>
        </van-field>
        <p class="reg_p">*如果一分钟内没有收到验证码请重新获取</p>
        <!-- button -->
        <div class="bottom">
          <van-button
            round
            block
            type="info"
            color="#616edf"
            class="formClass_btn"
            @click="handleSubmit"
          >申请解冻结</van-button>
        </div>
      </van-form>
    </div>
    <!-- 查询说明 -->
    <div class="lt-freeze-description">
      <h4>查询说明：</h4>
      <p>1、本页面功能仅限官方iOS、官方安卓、官方鸿蒙区组，渠道区组暂不支持查询</p>
      <p>2、本页面只能申请解冻保护性冻结账号解除，无法解除违规封停</p>
      <p>3、解除保护性冻结前必须要账号申诉通过后，重置并绑定手机号码方可申请解冻，申诉失败或未审核前无法申请解冻，<a href="https://lt0.site/ezD4O0">点击这里</a>账号申诉</p>
      <p>4、若是申诉通过已重置手机号码还未绑定手机，账号完善信息：<a href="https://id.leiting.com/accountCenter/accountList/bindPhoneNum">点击这里</a></p>
    </div>
  </div>
</template>

<script>
import rules from '@/mixins/validator'
import sendCode from '@/mixins/sendCode'
import { ltCaptcha } from '@/utils/ltCaptcha'
import { throttle } from '@/utils/debounce.js'
import headerItem from '@/views/accountCenter/common/header'
import * as api from '@/api/account-self-manage/accountFreeze'
import * as apiInfo from '@/api/account-center-manage/accountInfo'
import { send_phone_code } from '@/api/account-self-manage/accountAppeal'

export default {
  name: 'AccountProtectUnfreeze',
  components: {
    headerItem
  },
  mixins: [sendCode],
  data() {
    return {
      columns: [],
      rules: rules,
      unfreezeParams: {},
      currentIndex: 0,
      titleArray: ['解除保护性冻结', '首页', '账号自助管理', '解除保护性冻结']
    }
  },
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.appeal').className = ['appeal accountFreezeH5 accountCommonH5']
    } else {
      document.querySelector('.appeal').className = ['appeal accountFreezeWeb accountCommonWeb']
    }
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      apiInfo.info().then(res => {
        console.log(res)
        if (res && res.status == 0) {
          this.userInfo = res.data
        }
      })
    },
    navBarClick() {
      if (this.currentIndex == 1) {
        this.currentIndex = 0
      } else {
        this.$router.go(-1)
      }
    },
    handleSubmit: throttle(function() {
      if (!this.unfreezeParams.phone) {
        this.$msg('请输入手机号')
        return
      }
      if (!this.unfreezeParams.phoneCode) {
        this.$msg('请输入手机验证码')
        return
      }
      if (!window.ltlAccount.isLogin()) {
        this.$msg('请先完成登录', 'warning')
        setTimeout(() => {
          window.ltlLoginModal.open()
        }, 1000)
        return
      }
      this.$ssd.track('leiting_unfreeze')
      this.$loading.show()
      api.unfreeze_apply(this.unfreezeParams).then((res) => {
        this.$loading.hide()
        if (res.status === 0) {
          this.$msg('您已经成功解除账号保护性冻结。', 'success')
        }
      }, () => {
        this.$loading.hide()
      })
    }, 300),
    getCode() {
      if (!this.unfreezeParams.phone) {
        this.$msg('请输入手机号')
        return
      }
      if (!window.ltlAccount.isLogin()) {
        this.$msg('请先完成登录', 'warning')
        setTimeout(() => {
          window.ltlLoginModal.open()
        }, 1000)
        return
      }
      ltCaptcha((captcha) => {
        send_phone_code({
          type: 'SELF_ACCOUNT_UNFREEZE',
          phoneNum: this.unfreezeParams.phone,
          captcha
        }).then(res => {
          if (res.status == 0) {
            this.$msg('短信发送成功', 'success')
            this.startTimer()
          }
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';
@import '~assets/css/accountCenter/accountFreeze.styl';

</style>
